class MenuDrawerTabs extends HTMLElement {
  connectedCallback() {
    this.defaultTab = this.dataset.defaultTab || 'womens';
    this.tabs = this.querySelectorAll('[data-tab]');
    this.panels = this.querySelectorAll('[data-gender]');
    this._activeTrigger = null;

    this._initTabs();
    this._initSlides();
    this._initDrawerReset();
  }

  _initTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        if (tab.classList.contains('menu-drawer__tab--active') && tab.dataset.href) {
          window.location.href = tab.dataset.href;
          return;
        }
        event.preventDefault();
        this._activateTab(tab.dataset.tab);
      }, true);
    });
  }

  _activateTab(gender) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === gender;
      tab.classList.toggle('menu-drawer__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      if (panel.dataset.gender === gender) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
        this._resetSlides(panel);
      }
    });
  }

  _initSlides() {
    // Strip hidden attribute set in Liquid; visibility controlled by CSS opacity
    this.querySelectorAll('.menu-drawer__slide--sub').forEach((s) => s.removeAttribute('hidden'));

    // Capture phase prevents theme's MenuDrawer closing the drawer on sub-menu trigger clicks
    this.querySelectorAll('[data-target-slide]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        const targetId = trigger.dataset.targetSlide;
        const slide = this.querySelector(`[data-slide="${targetId}"]`);
        if (!slide) return;

        const track = trigger.closest('.menu-drawer__slides-track');
        const mainSlide = track?.querySelector('.menu-drawer__slide--main');

        // Layout change (promo display:none) happens first; transitions start together in the next frame
        trigger.closest('.menu-drawer__gender-panel')?.classList.add('menu-drawer__gender-panel--sub-active');
        trigger.setAttribute('aria-expanded', 'true');
        this._activeTrigger = trigger;

        requestAnimationFrame(() => {
          mainSlide?.classList.add('is-hidden');
          slide.classList.add('is-active');
          slide.querySelector('[data-slide-back]')?.focus();

          const viewport = track?.closest('.menu-drawer__slides-viewport');
          if (viewport) {
            slide._heightObs?.disconnect();
            const ro = new ResizeObserver(() => {
              viewport.style.height = slide.scrollHeight + 'px';
            });
            ro.observe(slide);
            slide._heightObs = ro;
            viewport.style.height = slide.scrollHeight + 'px';
          }
        });
      }, true);
    });

    this.querySelectorAll('[data-slide-back]').forEach((backBtn) => {
      backBtn.addEventListener('click', (event) => {
        event.stopImmediatePropagation();

        const subSlide = backBtn.closest('.menu-drawer__slide--sub');
        const track = subSlide?.closest('.menu-drawer__slides-track');
        const mainSlide = track?.querySelector('.menu-drawer__slide--main');

        backBtn.closest('.menu-drawer__gender-panel')?.classList.remove('menu-drawer__gender-panel--sub-active');

        if (this._activeTrigger) {
          this._activeTrigger.setAttribute('aria-expanded', 'false');
          this._activeTrigger.focus();
          this._activeTrigger = null;
        }

        requestAnimationFrame(() => {
          subSlide?._heightObs?.disconnect();
          if (subSlide) subSlide._heightObs = null;
          subSlide?.classList.remove('is-active');
          mainSlide?.classList.remove('is-hidden');

          const viewport = subSlide?.closest('.menu-drawer__slides-viewport');
          if (viewport) viewport.style.height = '';
        });
      }, true);
    });
  }

  _initDrawerReset() {
    const details = this.closest('details');
    if (!details) return;

    details.addEventListener('toggle', () => {
      if (!details.open) {
        this._activateTab(this.defaultTab);
        this.panels.forEach((panel) => this._resetSlides(panel));
        this._activeTrigger = null;
      }
    });
  }

  _resetSlides(panel) {
    panel.querySelectorAll('.menu-drawer__slides-track').forEach((track) => {
      track.querySelector('.menu-drawer__slide--main')?.classList.remove('is-hidden');
      track.querySelectorAll('.menu-drawer__slide--sub').forEach((slide) => {
        slide._heightObs?.disconnect();
        slide._heightObs = null;
        slide.classList.remove('is-active');
      });
      const viewport = track.closest('.menu-drawer__slides-viewport');
      if (viewport) viewport.style.height = '';
    });

    panel.querySelectorAll('[data-target-slide]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    panel.classList.remove('menu-drawer__gender-panel--sub-active');
  }
}

if (!customElements.get('menu-drawer-tabs')) customElements.define('menu-drawer-tabs', MenuDrawerTabs);
